var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-caption",staticStyle:{"max-height":"60vh","overflow":"auto"},attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"info","text":""},on:{"click":_vm.error}},[_vm._v("Simulate Error")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }